import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import TestingNumbersTable from "./TestingNumbersTable";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
    marginTop: 45,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  smallColumn: {
    width: "10px",
  },
}));

const TestingNumbers = () => {
  const classes = useStyles();

  const [dataObj, setDataObj] = useState({
    testingNums: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken("api/PhoneNumbers/testNumbers")
      .then((res) => res.json())
      .then((data) =>
        setDataObj({
          testingNums: data,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {dataObj.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <div className={classes.table}>
          <TestingNumbersTable data={dataObj} />
        </div>
      )}
    </>
  );
};

export default TestingNumbers;
